import { Injectable } from '@angular/core';
import { StudentService } from './student.service';

@Injectable({ providedIn: 'root' })
export class UrlBuilderService {
  constructor(private studentService: StudentService) {}

  async buildTypeformUrl(baseUrl: string, student: any): Promise<string> {
    const userData = await this.gatherUserData(student);
    const params = new URLSearchParams();

    Object.entries(userData).forEach(([key, value]) => {
      if (value) {
        params.append(key, String(value));
      }
    });

    return `${baseUrl}#${params.toString()}`;
  }

  private async gatherUserData(student: any): Promise<Record<string, string>> {
    const [basicData, extendedData] = await Promise.all([
      Promise.resolve({
        id: student?.remoteId,
        first_name: student?.firstName,
        last_name: student?.lastName,
        phone: student?.phone,
        dob: student?.dob,
      }),
      this.studentService.fetchUserProperties().catch(() => ({})),
    ]);

    return {
      ...basicData,
      client_type: extendedData?.client_type || '',
    };
  }
}
